import { useState } from "react";
import { LocateFixed, Loader2, MapPin } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n";

export const mapsLink = (g) => `https://www.google.com/maps?q=${g.lat},${g.lng}`;

export function LocateMe({ geo, onFound }) {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const locate = () => {
    if (!navigator.geolocation) { toast.error(t("loc.err")); return; }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(async (p) => {
      const g = { lat: +p.coords.latitude.toFixed(6), lng: +p.coords.longitude.toFixed(6) };
      let city = "", neighborhood = "";
      try {
        const r = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=16&lat=${g.lat}&lon=${g.lng}`);
        const a = (await r.json()).address || {};
        city = a.city || a.town || a.village || a.municipality || "";
        neighborhood = a.suburb || a.neighbourhood || a.hamlet || a.road || "";
      } catch { /* address lookup is optional */ }
      onFound({ geo: g, city, neighborhood });
      toast.success(t("loc.ok"));
      setBusy(false);
    }, () => { toast.error(t("loc.err")); setBusy(false); }, { enableHighAccuracy: true, timeout: 15000 });
  };
  return (
    <div className="sm:col-span-2 rounded-2xl border border-blue-200 bg-blue-50/60 p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="locate-me">
      <button type="button" onClick={locate} disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white px-5 h-11 font-semibold transition-colors disabled:opacity-60" data-testid="locate-me-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LocateFixed className="h-4 w-4" />}{t("loc.btn")}
      </button>
      {geo && (
        <a href={mapsLink(geo)} target="_blank" rel="noreferrer" className="text-sm text-blue-800 inline-flex items-center gap-1 hover:underline" data-testid="locate-me-link">
          <MapPin className="h-4 w-4" />{t("loc.saved")} · {t("loc.map")}
        </a>
      )}
    </div>
  );
}
